import React from "react";
import { ScheduleConflictItem } from "@myapp/contract";
import Modal from "../../overlay/Modal/Modal";
import { Button } from "../../controls/Button/Button";
import { ConflictItemList } from "../ConflictItemList/ConflictItemList";

type Props = {
  open: boolean;
  blockers: ScheduleConflictItem[];
  onClose: () => void;
  onGoToReschedule: () => void;
  /** Overridable because the blocked operation differs: an absence, a Termin, a task. */
  description?: string;
};

const DEFAULT_DESCRIPTION =
  "Die folgenden abgeschlossenen Einträge blockieren diesen Zeitraum. Bitte planen Sie diese " +
  "zuerst um, bevor Sie die Abwesenheit erfassen.";

export const BlockerDialog: React.FC<Props> = ({
  open,
  blockers,
  onClose,
  onGoToReschedule,
  description = DEFAULT_DESCRIPTION,
}) => {
  return (
    <Modal
      empty
      show={open}
      setShow={(val) => { if (!val) onClose(); }}
      // `empty` skips the header, so the dialog has no title to be labelled by.
      ariaLabel="Abgeschlossene Aufgaben oder Termine im Zeitraum"
      className="flex max-h-[90vh] w-[520px] flex-col gap-4 overflow-hidden p-6"
    >
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-red-100">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="#DC2626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <p className="text-base font-semibold text-gray-900">
          Abgeschlossene Aufgaben oder Termine im Zeitraum
        </p>
      </div>

      <p className="text-sm text-gray-600">{description}</p>

      <ConflictItemList items={blockers} />

      <div className="flex gap-3">
        <Button
          onClick={onGoToReschedule}
          className="flex-1 rounded-[30px] bg-[#16499A] font-bold text-white h-[46px]"
          type="button"
        >
          Zur Umplanung
        </Button>
        <Button
          onClick={onClose}
          className="flex-1 rounded-[30px] bg-[#716D6B] font-bold text-white h-[46px]"
          type="button"
        >
          Schließen
        </Button>
      </div>
    </Modal>
  );
};

export default BlockerDialog;
